import { createUseStyles } from 'react-jss'
import { darkGrey, mediumGrey } from '../../../styles/const/colors'
import { phonesDown, tabletDown } from '../../../styles/const/breakpoints'
import { siteLink } from '../../../styles/common'

const useStyles = createUseStyles({
  infoContainer: {
    textAlign: 'center',
    marginTop: ({ centered }) => (centered ? 150 : 65),
    maxWidth: 800,
    marginRight: 'auto',
    marginLeft: 'auto'
  },
  title: {
    color: darkGrey,
    fontSize: 24,
    marginTop: 24,
    marginBottom: 16,
    lineHeight: 0.885
  },
  description: {
    color: ({ greyDescription }) => greyDescription && mediumGrey,
    fontSize: 16,
    lineHeight: 1.1,
    '& a': {
      extend: siteLink
    }
  },
  [`@media screen and (${tabletDown})`]: {
    infoContainer: {
      marginTop: ({ centered }) => (centered ? 120 : 65)
    }
  },
  [`@media screen and (${phonesDown})`]: {
    infoContainer: {
      // we use such workaround because in other way styles don't work, because we use conditions before
      marginTop: () => 65
    }
  }
})

export default useStyles
